import React from 'react';
import { clsx } from 'clsx';
import { PaymentStatus, PaymentStatus as PaymentStatusType, QUOTATION_STATUS_COLORS, QuotationStatus } from '../../types/billing';
import { CheckCircle, Clock, AlertTriangle, Ban, CreditCard } from 'lucide-react';

interface PaymentStatusBadgeProps {
  status: PaymentStatusType;
}

const PAYMENT_CONFIG: Record<PaymentStatus, { icon: React.ReactNode; label: string; className: string }> = {
  pending: { icon: <Clock className="w-3 h-3" />, label: 'Pending', className: 'bg-amber-500/10 text-amber-400 border-amber-500/20' },
  partial: { icon: <CreditCard className="w-3 h-3" />, label: 'Partial', className: 'bg-sky-500/10 text-sky-400 border-sky-500/20' },
  paid: { icon: <CheckCircle className="w-3 h-3" />, label: 'Paid', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  overdue: { icon: <AlertTriangle className="w-3 h-3" />, label: 'Overdue', className: 'bg-rose-500/10 text-rose-400 border-rose-500/20' },
  cancelled: { icon: <Ban className="w-3 h-3" />, label: 'Cancelled', className: 'bg-slate-700/50 text-slate-400 border-slate-600/50' },
};

export const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status }) => {
  const config = PAYMENT_CONFIG[status];
  return (
    <span className={clsx('inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border', config.className)}>
      {config.icon}
      {config.label}
    </span>
  );
};

interface QuotationStatusBadgeProps {
  status: QuotationStatus;
}

const QUOTATION_CONFIG: Record<QuotationStatus, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-slate-700/50 text-slate-400 border-slate-600/50' },
  submitted: { label: 'Submitted', className: 'bg-sky-500/10 text-sky-400 border-sky-500/20' },
  approved: { label: 'Approved', className: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' },
  rejected: { label: 'Rejected', className: 'bg-rose-500/10 text-rose-400 border-rose-500/20' },
  expired: { label: 'Expired', className: 'bg-slate-700/50 text-slate-400 border-slate-600/50' },
};

export const QuotationStatusBadge: React.FC<QuotationStatusBadgeProps> = ({ status }) => {
  const config = QUOTATION_CONFIG[status];
  return (
    <span className={clsx('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border', config.className)}>
      {config.label}
    </span>
  );
};
